/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VwbAddGroupMemberRequest
 */
export interface VwbAddGroupMemberRequest {
    /**
     * Email of the user to add to the group
     * @type {string}
     * @memberof VwbAddGroupMemberRequest
     */
    email: string;
    /**
     * Role to grant (MEMBER or ADMIN)
     * @type {string}
     * @memberof VwbAddGroupMemberRequest
     */
    role: VwbAddGroupMemberRequestRoleEnum;
    /**
     * Reason for adding the member
     * @type {string}
     * @memberof VwbAddGroupMemberRequest
     */
    reason: string;
}


/**
 * @export
 */
export const VwbAddGroupMemberRequestRoleEnum = {
    MEMBER: 'MEMBER',
    ADMIN: 'ADMIN'
} as const;
export type VwbAddGroupMemberRequestRoleEnum = typeof VwbAddGroupMemberRequestRoleEnum[keyof typeof VwbAddGroupMemberRequestRoleEnum];


/**
 * Check if a given object implements the VwbAddGroupMemberRequest interface.
 */
export function instanceOfVwbAddGroupMemberRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function VwbAddGroupMemberRequestFromJSON(json: any): VwbAddGroupMemberRequest {
    return VwbAddGroupMemberRequestFromJSONTyped(json, false);
}

export function VwbAddGroupMemberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbAddGroupMemberRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'role': json['role'],
        'reason': json['reason'],
    };
}

export function VwbAddGroupMemberRequestToJSON(value?: VwbAddGroupMemberRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'role': value.role,
        'reason': value.reason,
    };
}

